<template>
    <div class="border rounded p-2">
        <b-media
          no-body
          vertical-align="center"
          class="flex-column flex-md-row"
        >
          <b-media-aside>
            <b-img
              ref="refPreviewEl"
              :src="imgLogo"
              height="65"
              width="160"
              class="rounded mr-2 mb-1 mb-md-0"
            />
          </b-media-aside>
          <b-media-body>
            <small class="text-muted"
              >Recommend image resolution 65px. * 160px.</small
            >
            <b-card-text class="my-50"> </b-card-text>
            <div class="d-inline-block">
              <b-form-file
                ref="refInputEl"
                v-model="logoFile"
                accept=".jpg, .png, .gif, .webp,"
                placeholder="Choose file"
                @input="inputImageRenderer"
              />
            </div>
            <!-- <b-card-text class="my-50">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                v-if="imgLogo"
                @click="revomeImage"
                >Remove Image</b-button
              >
            </b-card-text> -->
          </b-media-body>
        </b-media>
    </div>
</template>

<script>
import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton, BTabs, BTab,
    BCard, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile,
} from 'bootstrap-vue'
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import Ripple from 'vue-ripple-directive'
import { ref,onUnmounted } from '@vue/composition-api'
import { $themeConfig } from '@themeConfig'
import store from '@/store'

export default {
    components: {
        BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback,
        BButton, BTabs, BTab, BCard,
        BAvatar, BLink, BMedia, BMediaAside, BMediaBody, BImg, BCardText, BFormFile,
    },

    directives: {
        Ripple,
    },

    props: {
        imgLogo: {
            type: String
        }
    },

    setup(props, { emit }) {
        const {  appRef } = $themeConfig.app
        const refInputEl = ref(null);
        const refPreviewEl = ref(null);
        const logoFile = ref(null)
        const getLocalSite = JSON.parse(localStorage.getItem('site'))

        const { inputImageRenderer } = useInputImageRenderer(
            refInputEl,
            (base64) => {
                refPreviewEl.value.src = base64;
                uploadImage()
            },
        );

        const uploadImage = () => {
            let formData = new FormData();
            formData.append('path', `/var/www/html/uploadfiles/uploads/${appRef}/amenities/`);
            formData.append('savepath', `uploads/${appRef}/allergies/`);
            formData.append('iconFile', refInputEl.value.files[0])

            const res = store.dispatch('permissions-settings/updateLogoData', {
                sites_id: getLocalSite.id,
                formData: formData
            })
        }

        // const revomeImage = () => {
        //     refPreviewEl.value.src = require("@/assets/images/no-image.png");
        //     uploadImage()
        // };

        return {
            refInputEl,
            refPreviewEl,
            inputImageRenderer,
            // revomeImage,
            logoFile,
            uploadImage,
        }
    }
}
</script>